import script from "./MintCollateralLegendItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MintCollateralLegendItem.vue?vue&type=script&setup=true&lang=js"

import "./MintCollateralLegendItem.vue?vue&type=style&index=0&id=3d914226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d914226"]])

export default __exports__